export default __webpack_public_path__ + "6feee25a7cc9263a62919f6df43f7c32.svg";